export const ROT = 'rot'
export const RUT = 'rut'
export const rutPercent = 50
export const rotPercent = 30
